class Loading {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        window.addEventListener("DOMContentLoaded", (event) => {
            this.show()
        })
        document.querySelectorAll('a').forEach(link => {
            if (link.dataset.hasOwnProperty('ignore')) {
                return
            }
            link.addEventListener('click', (event) => {
              event.preventDefault()
              this.hide()
              setTimeout(() => {
                    window.location.href = link.href
              }, 300)
            })
        })
        document.querySelectorAll('form').forEach(form => {
            if (form.dataset.hasOwnProperty('ignore')) {
                return
            }
            form.addEventListener('submit', (event) => {
                event.preventDefault()
                this.hide()
                setTimeout(() => {
                    form.submit();
                }, 300)
            })
        })

    }

    show() {
        setTimeout(() => {
            document.body.classList.add('loading--end')
        }, 500)
    }
    hide() {
        document.body.classList.remove('loading--end')
    }
}

export default Loading